/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type removeCollaboratorModal_collaborator$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type collaborator_collaborator$ref: FragmentReference;
declare export opaque type collaborator_collaborator$fragmentType: collaborator_collaborator$ref;
export type collaborator_collaborator = {|
  +id: string,
  +rowId: any,
  +name: string,
  +email: string,
  +avatar: ?string,
  +teams: {|
    +totalCount: number,
    +nodes: $ReadOnlyArray<?{|
      +id: string,
      +rowId: any,
      +avatar: ?string,
      +name: string,
      +canUpdate: ?boolean,
    |}>,
  |},
  +$fragmentRefs: removeCollaboratorModal_collaborator$ref,
  +$refType: collaborator_collaborator$ref,
|};
export type collaborator_collaborator$data = collaborator_collaborator;
export type collaborator_collaborator$key = {
  +$data?: collaborator_collaborator$data,
  +$fragmentRefs: collaborator_collaborator$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": {},
      "kind": "LocalArgument",
      "name": "teamFilter",
      "type": "TeamFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "collaborator_collaborator",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "teamFilter"
        }
      ],
      "concreteType": "TeamsConnection",
      "kind": "LinkedField",
      "name": "teams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v3/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canUpdate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "teamFilter",
          "variableName": "teamFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "removeCollaboratorModal_collaborator"
    }
  ],
  "type": "User"
};
})();
// prettier-ignore
(node/*: any*/).hash = '031299862abd3852a2f78849467c74a1';

module.exports = node;
